import { textEditingUpdateTextMaker } from 'utils/actions';

export const MAGAZINE_ARTICLES_FETCH = 'MAGAZINE_ARTICLES_FETCH';
export const MAGAZINE_ARTICLES_FETCH_SUCCESS = 'MAGAZINE_ARTICLES_FETCH_SUCCESS';
export const MAGAZINE_ARTICLES_FETCH_ERROR = 'MAGAZINE_ARTICLES_FETCH_ERROR';
export const magazineArticlesFetch = (page = 1, query, queryString) => ({type: MAGAZINE_ARTICLES_FETCH, page, query, queryString});

export const MAGAZINE_SIDEBAR_ARTICLES_FETCH = 'MAGAZINE_SIDEBAR_ARTICLES_FETCH';
export const MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS = 'MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS';
export const MAGAZINE_SIDEBAR_ARTICLES_FETCH_ERROR = 'MAGAZINE_SIDEBAR_ARTICLES_FETCH_ERROR';
export const magazineSidebarArticlesFetch = (page = 1, query, queryString) => ({type: MAGAZINE_SIDEBAR_ARTICLES_FETCH, page, query, queryString});

export const MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE = 'MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE';
export const magazineArticlesUpdatePossiblePage = (possiblePage, queryString) => ({type: MAGAZINE_ARTICLES_UPDATE_POSSIBLE_PAGE, possiblePage, queryString});

export const MAGAZINE_ARTICLE_PROFILE_FETCH = 'MAGAZINE_ARTICLE_PROFILE_FETCH';
export const MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS = 'MAGAZINE_ARTICLE_PROFILE_FETCH_SUCCESS';
export const MAGAZINE_ARTICLE_PROFILE_FETCH_ERROR = 'MAGAZINE_ARTICLE_PROFILE_FETCH_ERROR';
export const magazineArticleProfileFetch = magazineArticleId => ({type: MAGAZINE_ARTICLE_PROFILE_FETCH, magazineArticleId});

export const MAGAZINE_ARTICLES_RECEIVED = 'MAGAZINE_ARTICLES_RECEIVED';
export const magazineArticlesReceived = result => ({type: MAGAZINE_ARTICLES_RECEIVED, result});

export const MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT = 'MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT';
export const magazineContributeEditingUpdateSubject = subject => ({type: MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT, subject});

export const MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT = 'MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT';
export const magazineContributeEditingUpdateText = textEditingUpdateTextMaker(MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT);

export const MAGAZINE_CONTRIBUTE_EDITING_RESET = 'MAGAZINE_CONTRIBUTE_EDITING_RESET';
export const magazineContributeEditingReset = () => ({type: MAGAZINE_CONTRIBUTE_EDITING_RESET});

export const MAGAZINE_EMOJIS_SHOW = 'MAGAZINE_EMOJIS_SHOW';
export const magazineEmojisShow = key => ({type: MAGAZINE_EMOJIS_SHOW, key});

export const MAGAZINE_EMOJIS_HIDE = 'MAGAZINE_EMOJIS_HIDE';
export const magazineEmojisHide = key => ({type: MAGAZINE_EMOJIS_HIDE, key});

export const MAGAZINE_ARTICLE_CREATE = 'MAGAZINE_ARTICLE_CREATE';
export const MAGAZINE_ARTICLE_CREATE_SUCCESS = 'MAGAZINE_ARTICLE_CREATE_SUCCESS';
export const MAGAZINE_ARTICLE_CREATE_ERROR = 'MAGAZINE_ARTICLE_CREATE_ERROR';
export const magazineArticleCreate = (title, text, successMessage) => ({type: MAGAZINE_ARTICLE_CREATE, title, text, successMessage});

export const MAGAZINE_ARTICLE_UPDATE = 'MAGAZINE_ARTICLE_UPDATE';
export const magazineArticleUpdate = (magazineArticleId, stateBeforeLocalUpdate, updates) => ({
  type: MAGAZINE_ARTICLE_UPDATE,
  stateBeforeLocalUpdate,
  magazineArticleId,
  updates
});

export const MAGAZINE_ARTICLE_FOLLOW = 'MAGAZINE_ARTICLE_FOLLOW';
export const MAGAZINE_ARTICLE_FOLLOW_SUCCESS = 'MAGAZINE_ARTICLE_FOLLOW_SUCCESS';
export const MAGAZINE_ARTICLE_FOLLOW_ERROR = 'MAGAZINE_ARTICLE_FOLLOW_ERROR';
export const magazineArticleFollow = (magazineArticleId, followed) => ({type: MAGAZINE_ARTICLE_FOLLOW, magazineArticleId, followed});

export const MAGAZINE_ARTICLE_FAVOURITE = 'MAGAZINE_ARTICLE_FAVOURITE';
export const MAGAZINE_ARTICLE_FAVOURITE_SUCCESS = 'MAGAZINE_ARTICLE_FAVOURITE_SUCCESS';
export const MAGAZINE_ARTICLE_FAVOURITE_ERROR = 'MAGAZINE_ARTICLE_FAVOURITE_ERROR';
export const magazineArticleFavourite = (magazineArticleId, favourite) => ({type: MAGAZINE_ARTICLE_FAVOURITE, magazineArticleId, favourite});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/actions.js
 **/